export default __webpack_public_path__ + "static/media/Mouse.c66a5aaf.svg";